<!-- 核收或核退 -->
<template>
    <div v-loading="loading">
        <el-form :model="submitData" label-width="80px" ref="submitData">
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item :label="submitData.OPType == 0 ? '核收总额' : '核付总额'">
                            <el-input type="number" v-model="CollectionAmount" disabled></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item :label="submitData.OPType == 0 ? '剩余可收' : '剩余可付'">
                            <el-input type="number" v-model="UnPaid" disabled></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <!-- <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="结算方式" prop="PayType">
                            <el-select
                                v-model="submitData.PayType"
                                placeholder="请选择"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item in payWayList"
                                    :key="item.Value"
                                    :label="item.Text"
                                    :value="item.Value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-col>-->
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item :label="submitData.OPType == 0 ? '已收总额' : '已付总额'">
                            <el-input type="number" v-model="Paid" disabled></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item :label="submitData.OPType == 0 ? '减收金额' : '减付金额'">
                            <el-input type="number" v-model="submitData.NowPay"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item :label="submitData.OPType == 0 ? '收款日期' : '付款日期'">
                            <el-date-picker
                                v-model="submitData.PayTime"
                                align="right"
                                type="date"
                                placeholder="选择日期"
                                style="width:100%"
                            ></el-date-picker>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="18">
                    <div class="grid-content bg-purple">
                        <el-form-item label="备注">
                            <el-input v-model="submitData.Remark"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
        <div class="btn-ctn">
            <el-button size="small" class="search-btn" @click="cancel()">取消</el-button>
            <el-button size="small" class="search-btn btn-primary" @click="submitForm()">提交</el-button>
        </div>
    </div>
</template>
<script>
export default {
  name: "",
  props: ["SettleId", "SumPayable", "Type", "UnPaid"],
  components: {},
  data() {
    return {
      loading: false,
      payWayList: [],
      CollectionAmount: 0,
      Paid: 0,
      submitData: {
        SettleId: this.SettleId,
        PayType: "",
        Remark: "",
        NowPay: 0,
        PayTime: "",
        OPType: 0
      }
    };
  },
  created: function() {
    var aData = new Date();
    this.submitData.PayTime =
      aData.getFullYear() +
      "-" +
      (aData.getMonth() + 1) +
      "-" +
      aData.getDate();
  },
  mounted() {
    if (!this.SettleId) {
      this.$util.warningMsg("核算借款的结算单数据异常，请刷新后重新操作");
      return;
    }
    this.getPay();
    this.CollectionAmount = this.SumPayable;
    this.Paid = (this.SumPayable - this.UnPaid).toFixed(2);
    this.submitData.NowPay = this.UnPaid;
    this.submitData.OPType = this.Type;
  },
  methods: {
    cancel() {
      this.$emit("closeSettleUp");
    },
    submitForm() {
      this.$refs["submitData"].validate(valid => {
        if (valid) {
          if (this.UnPaid != this.submitData.NowPay) {
              let str = "减" + (this.Type == 0 ? "收金额必须等于剩余可收金额" : "付金额必须等于剩余可付金额");
              this.$util.warningMsg(str);
              return;
          }

          this.$confirm(
            "您确认要提交此核结款吗？一旦提交则该结余款将会被结清！",
            "提示",
            {
              confirmButtonText: "确定提交",
              cancelButtonText: "取消",
              type: "warning",
              center: false
            }
          )
            .then(() => {
              this.loading = true;
              this.$util
                .axiosPost({
                  url: "/api/RevenueManagement_N/SettleUpFinally",
                  data: this.submitData,
                  hideLoading: true
                })
                .then(res => {
                  this.$util.successMsg("结款成功");
                  this.$emit("closeSettleUp", this.submitData.NowPay);
                })
                .catch(() => {})
                .finally(() => {
                  this.loading = false;
                });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    //  结算方式
    getPay() {
      this.$util.getPay(1).then(data => {
        this.payWayList = data;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.dialog-content {
  margin: 5px;
}
.btn-ctn {
  text-align: right;
}
.el-row {
  margin-bottom: 0px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
